import { EventEmitter, OnInit } from '@angular/core';
var TagEmailInputComponent = /** @class */ (function () {
    function TagEmailInputComponent() {
        this.entries = [];
        this.showGrey = false;
        this.added = new EventEmitter();
        this.removed = new EventEmitter();
        this.sendButtonPressed = new EventEmitter();
    }
    Object.defineProperty(TagEmailInputComponent.prototype, "isValid", {
        get: function () {
            return (this.entries != null &&
                this.entries.length > 0 &&
                this.entries.every(function (e) { return e != null && e.length > 0; }));
        },
        enumerable: true,
        configurable: true
    });
    TagEmailInputComponent.prototype.ngOnInit = function () { };
    TagEmailInputComponent.prototype.onFormSubmitHandler = function ($event) {
        this.sendButtonPressed.emit(this.entries);
        this.entries = [];
        $event.preventDefault();
    };
    return TagEmailInputComponent;
}());
export { TagEmailInputComponent };



// WEBPACK FOOTER //
// ./src/app/components/_shared/tag-email-input/tag-email-input.component.ts.pre-build-optimizer.js